export const FEMALE = "FEMALE"
export const MALE = "MALE"

export const PUBLIC = "PUBLIC"
export const PRIVATE = "PRIVATE"
export const PROTECTED = "PROTECTED"
export const CLOSE_FRIENDS = "CLOSE_FRIENDS"

export const LIST = "list"
export const ITEM = "item"

export const CREATE = "create"
export const EDIT = "edit"
export const DELETE = "delete"
export const SHARE = "share"
export const TRANSFER = "transfer"
export const ADD = "add"

export const iOS = "iOS"
export const Windows = "Windows"
export const Android = "Android"
export const Unix = "Unix"
export const Mac = "Mac"
export const Linux = "Linux"
export const BlackBerry = "BlackBerry"

export const DEBOUNCE_WAIT = 300
export const REQUEST_DEBOUNCE = 1500
export const SCROLL_THRESHOLD = 100
export const MINIMIZED_PROFILE_BANNER_HEIGHT = 55
export const MINIMUM_PASSWORD_LENGTH = 8
export const MINIMUM_USERNAME_LENGTH = 4
export const OTP_LENGTH = 4
export const MAX_VISIBLE_GENIES = 3
export const GENIE_AVATAR_WRAPPER_DIMENSION = 28
export const GENIE_TRANSLATE = 6

export const LISTS = "LISTS"
export const ITEMS = "ITEMS"
export const FOLLOWERS = "FOLLOWERS"
export const FOLLOWINGS = "FOLLOWINGS"
export const PROFILE_TABS = {
  [LISTS]: 0,
  [ITEMS]: 1,
  [FOLLOWERS]: 2,
  [FOLLOWINGS]: 3
}

export const DEFAULT_OVERFLOW = "auto"

export const CREATE_LIST = "CREATE_LIST"
export const EDIT_LIST = "EDIT_LIST"
export const DELETE_LIST = "DELETE_LIST"
export const CREATE_ITEM = "CREATE_ITEM"
export const EDIT_ITEM = "EDIT_ITEM"
export const DELETE_ITEM = "DELETE_ITEM"
export const LIKE_ITEM = "LIKE_ITEM"

export const UNINITIALIZED = "uninitialized"
export const PENDING = "pending"
export const FULFILLED = "fulfilled"
export const REJECTED = "rejected"
export const FETCH_ERROR = "FETCH_ERROR"

export const SMALL = "small"
export const MEDIUM = "medium"

export const AUTH_LAYOUT = "AUTH"
export const MAIN_LAYOUT = "MAIN"

export const OWNER = "OWNER"
export const VIEWER = "VIEWER"

export const PROFILE = "profile"
export const UPDATE_AVATAR = "updateAvatar"
export const SETTINGS = "settings"
export const CONNECTION_BUTTON = "connectionButton"
export const TOGGLE_VIEW = "toggle_view"
export const MAKE_WISH_TRUE = "makeWishTrue"
export const ROLLBACK_TRUE_WISH = "rollbackTrueWish"
export const GET_GENIES = "getGenies"
export const UPDATE_CLOSE_FRIENDS = "updateCloseFriends"

export const CURRENT_PASSWORD = "current-password"
export const NEW_PASSWORD = "new-password"
export const CONFIRM_NEW_PASSWORD = "confirm-new-password"

export const CANCEL = "cancel"

export const SUCCESS = "success"
export const FAILED = "failed"

export const IRT = "IRT"
